module.exports = require('./type.kuaibo/style.js')
